import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { DateTimeFormat } from 'types/EventState';
import { formatDateAndTimeOnTimeZone } from 'utils/events';
import oveitLogo from '../../../assets/common/oveit-logo.svg';

interface FreeEventRegistrationPageSEOProps {
  isLoading: boolean;
  name: string;
  startsAt: string | null;
  dateTimeFormat: DateTimeFormat;
}

const FreeEventRegistrationPageSEO: React.FC<
  FreeEventRegistrationPageSEOProps
> = ({
  isLoading,
  name,
  startsAt,
  dateTimeFormat: { dateFormat, timeFormat, timezone },
}) => {
  const { t } = useTranslation();

  const pageTitle = isLoading
    ? t('freeEventRegistrationPage.pageTitleDefault')
    : t('freeEventRegistrationPage.pageTitle', { eventName: name });

  const pageDescription = isLoading
    ? t('freeEventRegistrationPage.pageDescriptionDefault')
    : startsAt
    ? t('freeEventRegistrationPage.pageDescriptionEventWithStartDate', {
        eventName: name,
        formattedDate: formatDateAndTimeOnTimeZone(
          startsAt,
          dateFormat,
          timeFormat,
          timezone,
          t('common.at'),
        ),
      })
    : t('freeEventRegistrationPage.pageDescriptionEventWithoutStartDate', {
        eventName: name,
      });

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:image" content={oveitLogo} />
    </Helmet>
  );
};

export default FreeEventRegistrationPageSEO;
